export type RegisterComponentResources = {
    [K in 'formLabel' |
    'fullNameLabel' |
    'fullNamePlaceHolder' |
    'fullNameRequiredErrMsg' |
    'fullNameMinCharactersErrMsg' |
    'fullNameMaxCharactersErrMsg' |
    'invalidFullNameErrMsg' |
    'mobileNumberLabel' |
    'preferredLanguageLabel' |
    'emailAddressLabel' |
    'mobileNumberPlaceHolder' |
    'mobileNumberContainsAlphabetsErrMsg' |
    'mobileNumberInvalidLengthErrMsg' |
    'mobileNumberLeadingZeroErrMsg' |
    'mobileNumberRepetitiveDigitsErrMsg' |
    'emailAddressPlaceHolder' |
    'fullNameRequiredErrMsg' |
    'fullNameMinCharactersErrMsg' |
    'mobileNumberRequiredErrMsg' |
    'mobileNumberInvalidPatternErrMsg' |
    'emailAddressInvalidPatternErrMsg' |
    'emailAddressRequiredErrMsg' |
    'registerBtnLabel' |
    'termsAndConditionInvalidErrMsg' |
    'termsAndConditionMsg' |
    'marketingOptedMsg' |
    'marketingOptedMsgUnsubscribe'
    ]: string;
};

// Default values for the resources
export const DefaultRegisterComponentResource: RegisterComponentResources = {
    formLabel: 'Register', fullNameLabel: 'Full Name',
    fullNamePlaceHolder: 'Enter your full name',
    preferredLanguageLabel: 'Preferred Translation Language',
    fullNameRequiredErrMsg: 'Full Name is required',
    fullNameMinCharactersErrMsg: 'A minimum of 2 characters are required',
    fullNameMaxCharactersErrMsg: 'Maximum 50 characters allowed',
    invalidFullNameErrMsg: 'Invalid Full Name',
    mobileNumberLabel: 'Mobile Number',
    mobileNumberPlaceHolder: 'Enter your mobile number',
    mobileNumberRequiredErrMsg: 'Mobile Number is required',
    mobileNumberInvalidPatternErrMsg: 'Invalid Mobile Number',
    mobileNumberContainsAlphabetsErrMsg: 'Mobile number cannot contain letters',
    mobileNumberInvalidLengthErrMsg: 'Mobile number must be exactly 10 digits',
    mobileNumberLeadingZeroErrMsg: 'Mobile number cannot start with zero',
    mobileNumberRepetitiveDigitsErrMsg: 'Mobile number cannot have all identical digits',
    emailAddressLabel: 'Email Address',
    emailAddressPlaceHolder: 'Enter your email',
    emailAddressRequiredErrMsg: 'Email address is required',
    emailAddressInvalidPatternErrMsg: 'Enter a valid email address.',
    registerBtnLabel: 'Register',
    termsAndConditionInvalidErrMsg: "You must accept the terms and conditions.",
    termsAndConditionMsg: ' By checking this box, I confirm that I am at least 18 years of age, and that I accept all of the Terms of Use and our Privacy Policy.',
    marketingOptedMsg: ' I agree to receive product updates, feature announcements, and occasional promotional offers.',
    marketingOptedMsgUnsubscribe: ' Unsubscribe anytime.'
};
